import BaseRepository from './base.repository';

class SymptomsRepository extends BaseRepository {
  constructor() {
    super('/symptoms');
  }

  getTrends(params) {
    return this.client.get('/trends', params);
  }

  getHistory(params) {
    return this.client.get('/history', params);
  }

  getExpected() {
    return this.client.get('/expected');
  }

  get(mainUnique) {
    return this.client.get(`/${mainUnique}`);
  }

  submit(request) {
    return this.client.post('/submissions', request);
  }
}

export default new SymptomsRepository();
